import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useAuth } from 'context/AuthContext';

import LoginPage from 'components/Login';
import Layout from 'components/Layout';
import MainPage from 'components/Main';
import BuildHistoryPage from 'components/BuildHistoryPage';
import WarCheckPage from 'components/WarCheckPage';
import AdminPage from 'components/Admin';
import ConfigGeneratorPage from 'components/ConfigGenerator';

function ProtectedRoute({ children, adminOnly = false }) {
    const { isAuthenticated, isAdmin, loading } = useAuth();

    if (loading) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (adminOnly && !isAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
}

function PublicRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return null;
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default function AppRoutes() {
    return (
        <Routes>
            <Route
                path="/login"
                element={
                    <PublicRoute>
                        <LoginPage />
                    </PublicRoute>
                }
            />
            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="/" element={<MainPage />} />
                <Route path="/history" element={<BuildHistoryPage />} />
                <Route path="/war-check" element={<WarCheckPage />} />
                <Route path="/config-generator" element={<ConfigGeneratorPage />} />
                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute adminOnly>
                            <AdminPage />
                        </ProtectedRoute>
                    }
                />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
